import { render } from "./verify_courier.vue?vue&type=template&id=812af49c"
import script from "./verify_courier.vue?vue&type=script&lang=js"
export * from "./verify_courier.vue?vue&type=script&lang=js"

import "./verify_courier.vue?vue&type=style&index=0&id=812af49c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__